export const SET_TOP_RTB_STATS = 'SET_TOP_RTB_STATS';
export const SET_TOP_RTB_FAIL_REASONS = 'SET_TOP_RTB_FAIL_REASONS';
export const SET_RTB_STATS = 'SET_RTB_STATS';
export const SET_RTB_FAIL_REASONS = 'SET_RTB_FAIL_REASONS';